import { SET_ACTIVE_PAGE } from '../actionsTypes';
import { setSession, getSession } from '../../utilites';

const PAGINATION_STATE = 'PAGINATION_STATE';
const initialState = getSession(PAGINATION_STATE) || {
  activePage: 0,
};

const carStatusReducer = (state = initialState, action) => {
  const newState = (action.type === SET_ACTIVE_PAGE)
    ? { ...state, activePage: action.payload } : state;
  setSession(PAGINATION_STATE, newState);
  return newState;
};

export default carStatusReducer;
